var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 86",
    style: {
      enableBackground: "new 0 0 120 86"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#05596E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.9,46.3 26.9,48.6 11.9,44.9 11.9,44.9 9.2,45.5 9.2,43.3 11.9,42.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3.8,42.9 3.8,48.6 11.9,46.6 26.9,50.3 26.9,52.6 11.9,48.9 1.9,51.4 1.9,41 11.9,38.6 26.9,42.3  26.9,44.6 11.9,40.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.9,40.6 20.1,35.6 11.9,37.1 11.9,34.9 20.1,33.3 26.9,38.3  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38,52c-1.2-0.5-2.2-1.3-3-2.5l1-1.1c0.9,1.1,1.8,1.9,2.7,2.3c1,0.4,1.9,0.6,2.9,0.6c1.4,0,2.5-0.3,3.2-0.9 c0.8-0.6,1.2-1.3,1.2-2.2c0-0.9-0.4-1.6-1.3-2.2c-0.8-0.5-2.1-1.2-3.7-1.8c-1.3-0.5-2.4-1.1-3.3-1.6s-1.6-1.1-2-1.8 S35,39.4,35,38.4c0-1.1,0.3-2.1,0.9-2.8c0.6-0.8,1.4-1.4,2.4-1.8s2.1-0.6,3.2-0.6c0.9,0,1.7,0.1,2.5,0.4c0.8,0.3,1.6,0.7,2.2,1.2 c0.7,0.5,1.2,1.1,1.5,1.8l-1,1.1c-0.5-1-1.2-1.7-2.2-2.2c-1-0.5-2-0.8-3.1-0.8c-0.9,0-1.7,0.1-2.2,0.4s-1.1,0.6-1.4,1 s-0.5,0.8-0.5,1.3c0,0.7,0.2,1.2,0.6,1.6s1,0.8,1.8,1.2c0.8,0.3,1.8,0.8,2.9,1.3c1.1,0.5,2.1,1,2.9,1.6c0.8,0.5,1.5,1.1,1.9,1.8 c0.5,0.7,0.7,1.4,0.7,2.3c0,1-0.3,2-0.8,2.8c-0.6,0.9-1.3,1.5-2.4,2c-1,0.5-2.2,0.8-3.7,0.8C40.4,52.8,39.2,52.5,38,52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.3,33.3h3.3v19.2h-3.3V33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.1,33.3h12.2v1.5h-8.9v7.4H74v1.5h-6.7v7.4h8.9v1.5H64.1V33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.2,33.3l-8.9,19.4l-8.5-19.4h3.6l6,13.6l6.2-13.6C96.6,33.3,98.2,33.3,98.2,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.1,33.3v19.2h-1.5l-12.1-14.2v14.2H103V33.3h1.5l12.1,14.2V33.3H118.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a2206515667dfa1c3c8ca17fb4f9c4b8.svg";
export { ForwardRef as ReactComponent };